import { useState } from 'react'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { Wishlist } from '@pylot-data/pylotschema'
import { WishlistVisibilityEnum } from '@pylot-data/enums/WishlistVisibilityEnum.d'
import { CREATE_WISHLIST } from '../graphql/createWishlist'
import { useWishlist } from './use-wishlist'
import { useRouter } from 'next/router'

export interface OutputInterface {
    createWishlist: {
        wishlist: Wishlist
    }
}

export type WishlistInputVariable = {
    name: string
    visibility: WishlistVisibilityEnum
}

export interface WishlistOutputInterface {
    createWishList: (
        formInput: WishlistInputVariable
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
    isLoading: boolean
}

export const useCreateWishlist = (): WishlistOutputInterface => {
    const { mutate } = useWishlist()
    const [isLoading, setIsLoading] = useState(false)
    const { locale } = useRouter()

    const createWishList = async (formInput: WishlistInputVariable) => {
        setIsLoading(true)
        const response = await graphqlFetch<
            { input: WishlistInputVariable },
            OutputInterface
        >({ query: CREATE_WISHLIST, variables: { input: formInput }, locale })

        await mutate()
        setIsLoading(false)
        return response
    }

    return {
        isLoading,
        createWishList
    }
}
